import * as React from 'react';
import { ReactRouterHooks } from 'tree-wallet-client';
import Result from 'antd/es/result';
import Button from 'antd/es/button';
import { withReactRouter } from '../../Helper/HooksHelper';

interface ErrorPageProps extends ReactRouterHooks {
  template: '404'|'403'|'generic';
  subTitle?: string;
  contents?: string|React.ReactNode;
}

class ErrorPage extends React.Component<ErrorPageProps, any> {
  private templates = {
    '403': <Result
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page."
      extra={this.getBackHomeButton()}
    />,
    '404': <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={this.getBackHomeButton()}
    />,
    'generic': <Result
      status="error"
      title="Error"
      subTitle={this.props.subTitle}
      extra={this.getBackHomeButton()}
    >
      {this.props.contents}
    </Result>
  }

  constructor(props: ErrorPageProps) {
    super(props);
  }

  getBackHomeButton() {
    return <Button type="primary" onClick={() => this.props.navigate('/')}>Homepage</Button>;
  }

  render() {
    const { template } = this.props;
    return this.templates[template];
  }
}

export default withReactRouter(ErrorPage);
